<template>
  <div v-if="ready">
    <!-- 建議明細 -->
    <h4 class="text-green mt_15 mb_10">各建議保費明細</h4>
    <ItemTD
      v-for="(contractItem, index) in detailData.prod_list"
      :key="index"
      :contractData="contractItem"
      :contractIndex="index"
    />
    <!-- 各建議合計之應繳總保費 -->
    <h4 class="text-green mt_15 mb_10">各建議合計之應繳總保費</h4>
    <div class="totalPremium" :class="{ noDiscount: !showDiscount }">
      <div class="totalPremium__title">
        <div>繳別</div>
        <div>
          應繳總保費<br />
          (保費折減前)
        </div>
        <div v-if="showDiscount">
          應繳總保費<br />
          (保費折減後)
        </div>
      </div>
      <div
        class="totalPremium__item"
        v-for="(item, index) in detailData.total_premium_list"
        :key="index"
      >
        <div>{{ item.pay_freq_nm }}</div>
        <div>
          {{
            item.total_premium === "不適用"
              ? "不適用"
              : formatMethods(item.total_premium) + item.curr_nm
          }}
        </div>
        <div v-if="showDiscount">
          {{
            item.total_disc_premium === "不適用"
              ? "不適用"
              : formatMethods(item.total_disc_premium) + item.curr_nm
          }}
        </div>
      </div>
    </div>
    <div class="mt_3" style="font-size: 14px">
      ※僅針對商品適用繳別進行加總。
    </div>
  </div>
</template>

<script>
import ItemTD from "@/desktop/views/mf/components/2.Query/2-1-1.CreateDetail/Item_TD.vue";

import mf_Mixin from "@/desktop/views/mf/mixin";
export default {
  components: { ItemTD },
  mixins: [mf_Mixin],

  data() {
    return {
      detailData: null,
      ready: false
    };
  },
  computed: {
    MfViewing() {
      return this.$store.getters.MfViewing;
    },
    is_crm() {
      return this.MfViewing.inputType == "noId" ? "0" : "1";
    },
    showDiscount() {
      return this.detailData
        ? this.detailData.prod_list.every(prod => {
            return prod.has_disc ;
          })
        : false;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$mfAPI
        .MFB0_1150__getPremiumScheduleData({
          proposalMap: {
            ...this.deflationSaveData(this.MfViewing.saveData),
            agent_id: this.$store.state.userInfo.id,
            prod_idx: this.MfViewing.prod_idx
          }
        })
        .then(res => {
          this.detailData = res;
          this.ready = true;

          setTimeout(() => {
            this.registerHanlink();
          }, 50);
        });
    }
  }
};
</script>

<style lang="scss">
.totalPremium {
  max-width: 355px;
  border-radius: 4px;
  border: solid 1px #53c480;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
  &__title {
    width: 100%;
    display: flex;
    font-weight: 700;
    background-color: #e5f6ec;
    & > div {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    & > div:nth-of-type(1) {
      width: 40%;
      min-height: 50px;
    }
    & > div:nth-of-type(2) {
      width: 30%;
      flex-grow: 1;
    }
    & > div:nth-of-type(3) {
      width: 30%;
    }
  }
  &__item {
    width: 100%;
    display: flex;
    font-weight: 700;
    background-color: #fff;
    border: solid 1px #c2c5c7;
    & > div {
      text-align: center;
      display: flex;
      align-items: center;
      padding: 0 15px;
    }
    & > div:nth-of-type(1) {
      width: 40%;
      min-height: 50px;
      justify-content: flex-start;
    }
    & > div:nth-of-type(2) {
      width: 30%;
      justify-content: flex-end;
      flex-grow: 1;
    }
    & > div:nth-of-type(3) {
      width: 30%;
      justify-content: flex-end;
    }
  }
  &.noDiscount {
    max-width: 240px;
  }
}
</style>
